import { useTranslation } from "react-i18next";
// Components
import { SessionsHeaderMainDiv, SessionsHeaderDiv, SessionTitle } from "./styles";

const SessionsHeader = () => {
  const [t] = useTranslation("global");

  return (
    <SessionsHeaderMainDiv>
      <SessionsHeaderDiv>
        <SessionTitle width={"330px"}>{t("activities").toUpperCase()}</SessionTitle>
        <SessionTitle width={"150px"} textAlign>
          {t("rgsicu_startTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"150px"} textAlign>
          {t("rgsicu_endTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"150px"} textAlign>
          {t("rgsicu_totalTime").toUpperCase()}
        </SessionTitle>
        <SessionTitle width={"80px"} textAlign>
          {t("details").toUpperCase()}
        </SessionTitle>
      </SessionsHeaderDiv>
    </SessionsHeaderMainDiv>
  );
};

export default SessionsHeader;
